import { TypeOrderEnum } from '@model/enum/type-order.enum';
import { Subscription } from 'rxjs';
import { OnResizeService } from './../../services/on-resize.service';
import { Constants } from '@utils/constants';
import { Component, OnInit, OnDestroy, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { AbstractItem } from '@business/base/abstract-item';
import { WorkspaceNewService } from '@services/workspace-new.service';
import { MatDialog } from '@angular/material/dialog';
import { AbstractItemService } from '@business/base/abstract-item.service';
import { MessageQuote } from '@model/webFeeder/message-quote.model';
import { SimpleOrder } from '@model/simpleOrder';
import { SideEnum } from '@model/enum/side.enum';
import { BovBmfModel } from '@dto/custody-model-bov-bmf';
import { AppUtils } from '../../utils/app.utils';

@Component({
  selector: Constants.WINDOW_NAME_BILLET_QUICK,
  templateUrl: './billet-quick.component.html'
})
export class BilletQuickComponent extends AbstractItem implements OnInit, OnDestroy, OnChanges {

  @Input() data: any;
  @Input() messageQuote = new MessageQuote();
  @Input() symbol: string;
  @Input() maxLine = 5;
  @Input() model: SimpleOrder = new SimpleOrder();
  @Input() componentNameAux: string;
  @Input() isLoggedNegotiation: boolean;
  @Input() statusOmsOnline: boolean;
  @Input() hiddenHeaderFull: boolean;
  @Input() listPosition: BovBmfModel = new BovBmfModel();
  @Input() auctionHammer: boolean;
  @Input() isSubscribeBook = false;
  @Input() cardId: number;
  @Output() openConfirmationBillit = new EventEmitter<any>();
  componentName = Constants.TITLE_CARD_BILLET_QUICK;
  protected workspaceService: WorkspaceNewService;
  resizeCardBilletWksSubscripiton: Subscription;
  minimumAmount = 1;
  qtdValid = true;
  heightBillet = 285;
  priceValuesFormatOptions = Constants.PRICE_VALUES_FORMAT_OPTIONS;
  priceValuesFormatOptionsFuture = Constants.PRICE_VALUES_FORMAT_OPTIONS_FUTURES;
  termOperator: any;
  constructor(
    _dialog: MatDialog,
    _workspaceService: WorkspaceNewService,
    _itemService: AbstractItemService,
    private _onResizeService: OnResizeService,
  ) {
    super(_workspaceService, _dialog, _itemService);
    this.workspaceService = _workspaceService;
    this.dialog = _dialog;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.hiddenHeaderFull && !changes.hiddenHeaderFull.firstChange && changes.hiddenHeaderFull.previousValue !== changes.hiddenHeaderFull.currentValue
      || changes.symbol && changes.symbol.previousValue !== changes.symbol.currentValue
      || changes.auctionHammer && changes.auctionHammer.previousValue !== changes.auctionHammer.currentValue) {
      this.setMaxLineBook(null);
    }
  }

  ngOnInit() {
    this.componentName = '{' + this.componentNameAux + '}{' + this.componentName + '}';
    this.priceValuesFormatOptions.precision = this.model.priceTickSize;
    this.priceValuesFormatOptionsFuture.precision = this.model.priceTickSize;
    this.resizeCardBilletWksSubscripiton = this._onResizeService.resizeNumberLineBookWks$
      .subscribe(res => {
        if (res && res.type === this.data.type && res.id === this.data.id) {
          // this.setSizeCardScroll(res.height);
          console.log(res)
          console.log(this.data)

          setTimeout(() => { this.setMaxLineBook(res.height); }, 100);
        }
      });
  }

  ngOnDestroy() {
    this.resizeCardBilletWksSubscripiton.unsubscribe();
  }

  setMaxLineBook(height: number) {
    // TODO: Comentarios para DEBUG
    // console.log('\n--------------------------------------------------------');
    let marginBtn = 0;
    if (height) {
      marginBtn = 295;
      // console.log('MARGIN (height) > height: ' + height + ' | rows: ' + this.data.rows + ' | marginBtn: ' + marginBtn);
    } else if (this.data.rows) {
      marginBtn = this.data.rows <= 2 ? 285 : this.data.rows <= 3 ? 277 : 270;
      // console.log('MARGIN (data.rows) > height: ' + height + ' | rows: ' + this.data.rows + ' | marginBtn: ' + marginBtn);
    } else {
      marginBtn = 295;
      // console.log('MARGIN (else) > height: ' + height + ' | rows: ' + this.data.rows + ' | marginBtn: ' + marginBtn);
    }
    // console.log('MARGIN > height: ' + height + ' | rows: ' + this.data.rows + ' | marginBtn: ' + marginBtn);
    this.heightBillet = height ? height - (marginBtn) : (Constants.GRID_ROW_HEIGHT * this.data.rows) - (marginBtn);
    this.heightBillet = this.hiddenHeaderFull ? this.heightBillet + (this.model.auctionHammer ? 20 : 50) : this.model.auctionHammer ? this.heightBillet - 50 : this.heightBillet;
    if (document.getElementById('book-aggregated-component-' + this.cardId)) {
      let book = document.getElementById('book-aggregated-component-' + this.cardId).querySelector('.book-aggregated-component') as HTMLElement
      book.style.height = this.heightBillet + 'px';
    }
    const numerOfItemsThatFit = Math.floor(this.heightBillet / 13);
    this.maxLine = numerOfItemsThatFit && numerOfItemsThatFit > 0 ? Math.floor(this.heightBillet / (this.model.auctionHammer ? (this.hiddenHeaderFull ? 26 : 13) : 24)) : 5;
    // console.log('BOOK > height: ' + height + ' | rows: ' + this.data.rows + ' | marginBtn: ' + marginBtn + ' | maxLine: ' + this.maxLine);
    // console.log('--------------------------------------------------------');
    // console.log('hasSubscribeAggregated: ', this.hasSubscribeAggregated);
    // console.log('QUICK BOOK > isSubscribeBook: ', this.isSubscribeBook);
    if (!this.isSubscribeBook) {
      setTimeout(() => {
        this.subscribeAggregatedBook(true);
      }, 100);
    }
  }

  subscribeAggregatedBook(value: boolean) {
    this.isSubscribeBook = value;
  }

  verifyQuantity() {
    if (this.model.price < 0) {
      this.model.price = this.model.price * -1;
    }
    if (this.model.qtd < 0) {
      this.model.qtd = this.model.qtd * -1;
    }
    this.qtdValid = this.model.qtd < this.minimumAmount ? false : true;

    this.model.total = (this.model.price * this.model.qtd) / (AppUtils.convertNumberAux(this.messageQuote.quotationForm as any) * AppUtils.convertNumberAux(this.messageQuote.contractMultiplier as any))
  }

  validPrice(value: number) {
    if (value < 0) {
      return this.model.price = this.model.price * -1;
    }
    if (this.model.price > 999999) {
      return this.model.price = 999999;
    } else if (this.model.maxfloor > 9999999) {
      return this.model.maxfloor = 9999999;
    } else if (this.model.minqtd > 999999) {
      return this.model.minqtd = 999999;
    } else if (this.model.qtd > 999999) {
      return this.model.qtd = 999999;
    }
  }

  quantityDisabled() {
    return this.model.quote == null ? false : true;
  }

  openModalConfirm(value) {
    this.model.type = value.isMarket ? TypeOrderEnum.MARKET : TypeOrderEnum.LIMITED;
    this.model.side = value.side;
    this.openConfirmationBillit.emit(this.model);
  }

  confirmTradeAction(options: { side: SideEnum, qtd?: number }) {
    if (!options.side) {
      return;
    }
    this.model.side = options.side;
    if (options.qtd) {
      this.model.qtd = options.qtd;
    }
    this.openConfirmationBillit.emit(this.model);
  }

}
